import {Button, Grid} from "@material-ui/core"
import MaterialTable from "@material-table/core"
import * as React from "react"
import {useRef, useState} from "react"
import {MainAPI} from "../core/api/FApi"
import {t} from "../core/lang/lang"
import DeviceInfoAlert from "../common/DeviceInfoAlert"
import {connect} from "react-redux";
import store from "../store";
import {showExportAlertAction} from "../core/redux/actions/PageStateActions";

const generateExport = (kind, request) => {
    store.dispatch(showExportAlertAction(kind, request))
}

const DiagnosticsArchive = (props) => {
    const [columns, setColumns] = React.useState(null)
    const [notif, setNotif] = React.useState({open: false, deviceId: -1})

    const hasWritePermission = props.userOptions?.perms?.includes("table_reports_rw")

    const lastQueryParams = useRef({})

    if (columns == null) {
        MainAPI.editorsGetFields("diagnostics").then((data) => {
            setColumns(data.fields.map(item => {
                if (item.field === "device_serial_number")
                    return {
                        ...item,
                        render: rowData => <Button onClick={() => {
                            if (rowData.device_id > 0) setNotif({open: true, deviceId: rowData.device_id})
                        }} variant="contained" color="primary">{rowData.device_serial_number}</Button>
                    }
                else
                    return item
            }))
        }).catch(() => {
        })
        return (
            <>
                <Grid container spacing={1}>
                    <Grid item xs={1}/>
                    <Grid item xs={12}>
                        Loading...
                    </Grid>
                    <Grid item xs={1}/>
                </Grid>
            </>
        )
    } else
        return (
            <>
                <DeviceInfoAlert
                    open={notif.open}
                    handleClose={() => setNotif({open: false, deviceId: -1})}
                    data={notif.open ? notif : null}
                />
                <Grid container spacing={1}>
                    <Grid item xs={1}/>
                    <Grid item xs={12}>
                        <MaterialTable
                            title={t("DIAGNOSTICS")}
                            columns={columns}
                            options={{
                                pageSize: 10, search: false, filtering: true,

                                exportMenu: [{
                                    label: 'Export Excel',
                                    exportFunc: () => generateExport("diagnostics", lastQueryParams.current)
                                }]
                            }}
                            data={(query) => {
                                lastQueryParams.current = query
                                return MainAPI.diagnosticsList(query).then((result) => {
                                    return {
                                        data: result.result,
                                        page: query.page,
                                        totalCount: result.count,
                                    }
                                })
                            }
                            }
                            icons={props.tableIcons}
                            editable={hasWritePermission ? {
                                onRowDelete: (req: any) => MainAPI.diagnosticsDelete(req.id),
                            } : {}}
                        />
                    </Grid>
                    <Grid item xs={1}/>
                </Grid>
            </>
        )
}

const mapStateToProps = (state) => {
    return {
        userOptions: state.loadedOptions.userOptions,
    }
}

export default connect(mapStateToProps)(DiagnosticsArchive)